import React from 'react'
import { Button } from '@material-ui/core'
import useStyles from './FormFieldsStyle'
import DayTimePicker from '../DayTimePicker'

export default function Schedules({ field }) {
  const classes = useStyles()

  return (
    <>
      {field.schedules &&
        field.schedules.map((schedule, i) => (
          <div className={classes.scheduleWrapper}>
            <DayTimePicker
              schedule={schedule}
              onChange={(data) => field.updateScheduleData(i, data)}
            ></DayTimePicker>
            <Button
              variant="outlined"
              color="primary"
              className={classes.secondaryButton}
              onClick={() => field.removeSchedule(i)}
            >
              Borrar
            </Button>
          </div>
        ))}
      {field.schedules.length < 14 && (
        <Button
          variant="contained"
          color="primary"
          onClick={() => field.setSchedules([...field.schedules, {}])}
          fullWidth
          className={classes.primaryButton}
        >
          Agregar horario
        </Button>
      )}
    </>
  )
}
